import styled from 'styled-components'

const CookiePopupStyle = styled.div`
	.inline {
		display: inline;
	}
	.popup {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: var(--cream);
		position: fixed;
		left: 4.7%;
		bottom: 5%;
		z-index: 11;
		padding: var(--sp5x);
		border-radius: var(--sp3x);
		width: 54%;

		.imageCont {
			width: 7.3%;
			padding-top: 3.8%;
			height: fit-content;
			margin-right: var(--sp3x);
			.image {
				object-fit: contain;
			}
		}

		.cookieBtn {
			height: fit-content;
			border: none;
			outline: none;
			background-color: var(--orange);
			padding: var(--sp3x) var(--sp7x);
			border-radius: var(--sp5x);
			margin-left: var(--sp2x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		.popup {
			left: 4.7%;
			bottom: 5%;
			padding: var(--sp4x);
			border-radius: var(--sp3x);
			width: 57%;

			.imageCont {
				width: 7.3%;
				padding-top: 3.6%;
				margin-right: var(--sp2x);
			}

			.cookieBtn {
				padding: var(--sp2-5x) var(--sp6x);
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		.popup {
			left: 4%;
			bottom: 3%;
			padding: var(--sp4x) var(--sp3x);
			border-radius: var(--sp3x);
			width: 72%;

			.imageCont {
				width: 6.8%;
				padding-top: 3.4%;
				margin-right: var(--sp2x);
			}

			.cookieBtn {
				padding: var(--sp2x) var(--sp5x);
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		.popup {
			left: 5%;
			bottom: 3.1%;
			padding: var(--sp3x);
			border-radius: var(--sp3x);
			width: 90%;

			.imageCont {
				width: 5.6%;
				padding-top: 3.1%;
				margin-right: var(--sp2x);
			}

			.cookieBtn {
				padding: var(--sp2x) var(--sp4x);
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		.popup {
			left: 5%;
			bottom: 2%;
			padding: var(--sp3x);
			border-radius: var(--sp3x);
			width: 90%;

			.imageCont {
				width: 12%;
				padding-top: 3.7%;
				margin-right: var(--sp2x);
			}

			.cookieBtn {
				padding: var(--sp2x) var(--sp4x);
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.popup {
			flex-direction: column;
			align-items: flex-start;
			left: 5%;
			bottom: 2%;
			padding: var(--sp3x) var(--sp2x);
			border-radius: var(--sp3x);
			width: 90%;

			.imageCont {
				width: 7%;
				padding-top: 7%;
				margin-right: 0;
				margin-bottom: var(--sp2x);
			}

			.cookieBtn {
				padding: var(--sp1-5x) var(--sp3x);
				margin-left: 0;
				margin-top: var(--sp3x);
			}
		}
	}
`

export default CookiePopupStyle
